export default "__VITE_ASSET__B0shSX_I__"